var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgInsuranceBack(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 105,
    height: 70,
    viewBox: "0 0 105 70",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M95 0H10C4.47715 0 0 4.47716 0 10V45.2941V60C0 65.5229 4.47716 70 10 70H11.7353H95C100.523 70 105 65.5229 105 60V10C105 4.47715 100.523 0 95 0Z",
    fill: "#F1F1FE"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M76 7.99976H96",
    stroke: "#6C6D8A",
    strokeWidth: 4,
    strokeMiterlimit: 10
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M70 20.358L83.0062 16.5623L96 20.358V28.1421C96 36.3238 90.764 43.5874 83.0019 46.1737C75.2376 43.5874 70 36.3222 70 28.1385V20.358Z",
    fill: "#DDDDED"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M77.4531 30.3134H88.5465",
    stroke: "#F1F1FE",
    strokeWidth: 3,
    strokeLinecap: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M83 24.7667V35.8601",
    stroke: "#F1F1FE",
    strokeWidth: 3,
    strokeLinecap: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M9 22.9998H39",
    stroke: "#6C6D8A",
    strokeWidth: 4,
    strokeMiterlimit: 10
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M9 42.9998H22",
    stroke: "#6C6D8A",
    strokeWidth: 4,
    strokeMiterlimit: 10
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M9 32.9998H46",
    stroke: "#6C6D8A",
    strokeWidth: 4,
    strokeMiterlimit: 10
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.15,
    d: "M9 57.9998L96 57.9998",
    stroke: "#6C6D8A",
    strokeWidth: 10,
    strokeMiterlimit: 10
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInsuranceBack);
export default __webpack_public_path__ + "static/media/insuranceBack.6d8dfb93ee2666ccc47c7a76b27dc467.svg";
export { ForwardRef as ReactComponent };